import React from 'react'
import {QUESTION_TYPE} from '../../utils/constants'
import PercentageQuestionRender from '../../components/screens/surveyForms/questions/QuestionTypeComponents/PercentageQuestionRender'
import NumberSliderRender from '../../components/screens/surveyForms/questions/QuestionTypeComponents/NumberSliderRender'
import RankingQuestionRender from '../../components/screens/surveyForms/questions/QuestionTypeComponents/RankingQuestionRander'
import TextQuestionRender from '../../components/screens/surveyForms/questions/QuestionTypeComponents/TextQuestionRender'
import MultipleOptionRender from '../../components/screens/surveyForms/questions/QuestionTypeComponents/MultipleOptionRender'
import MultipleSelectRender from '../../components/screens/surveyForms/questions/QuestionTypeComponents/MultipleSelectRender'
import YesNoMayRender from '../../components/screens/surveyForms/questions/QuestionTypeComponents/YesNoMayRender'

// Renders the right answer widget for a question, shared by the live runner and
// the preview so both drive the same components. The template question is cloned
// first (nested arrays/objects copied) so a widget mutating its own props can
// never reach back into the survey's question list.
export default function renderSurveyQuestion(
  templateQuestion,
  {audience, updateAnswers, language}
) {
  const question = {
    ...templateQuestion,
    questionSettings: {...templateQuestion.questionSettings},
    followupQuestions:
      templateQuestion.followupQuestions?.length > 0
        ? [...templateQuestion.followupQuestions]
        : null,
    multiOptionResponseAttributes:
      templateQuestion.multiOptionResponseAttributes?.length > 0
        ? [...templateQuestion.multiOptionResponseAttributes]
        : null,
    sliderResponseAttributes: {...templateQuestion.sliderResponseAttributes},
    openResponseAttributes: {...templateQuestion.openResponseAttributes},
  }
  switch (question.questionType) {
    case QUESTION_TYPE.MULTIPLE_SELECT:
      return (
        <MultipleSelectRender
          question={{...question}}
          audience={audience}
          updateAnswers={updateAnswers}
          language={language}
        />
      )
    case QUESTION_TYPE.YES_NO:
    case QUESTION_TYPE.YES_NO_MAYBE:
      return (
        <YesNoMayRender
          question={{...question}}
          audience={audience}
          updateAnswers={updateAnswers}
          language={language}
        />
      )
    case QUESTION_TYPE.LIKERT:
    case QUESTION_TYPE.MULTIPLE_CHOICE:
      return (
        <MultipleOptionRender
          question={{...question}}
          audience={audience}
          updateAnswers={updateAnswers}
          language={language}
        />
      )
    case QUESTION_TYPE.COMMENTS:
      return (
        <TextQuestionRender
          question={{...question}}
          audience={audience}
          updateAnswers={updateAnswers}
          language={language}
        />
      )
    case QUESTION_TYPE.RANKING:
      return (
        <RankingQuestionRender
          question={{...question}}
          audience={audience}
          updateAnswers={updateAnswers}
          language={language}
        />
      )
    case QUESTION_TYPE.NUMBER_SLIDER:
      return (
        <NumberSliderRender
          question={{...question}}
          audience={audience}
          updateAnswers={updateAnswers}
          language={language}
        />
      )
    case QUESTION_TYPE.PERCENTAGE:
      return (
        <PercentageQuestionRender
          question={{...question}}
          audience={audience}
          updateAnswers={updateAnswers}
          language={language}
        />
      )
    default:
      return <div>Question type not available {question.questionType}</div>
  }
}
